import React from 'react'
import { useAppSelector } from '../../../core/hooks'
import { createSelector } from '@reduxjs/toolkit'
import { CardinalApiState } from '../../../core/services/auth.api'
import { skipToken } from '@reduxjs/toolkit/query'
import { useGetPractitionerQuery, useListHealthcarePartiesByParentIdQuery } from '../../../core/api/practitionerApi'
import { Skeleton } from 'antd'
import { DoctorsTable } from './components/DoctorsTable'

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    healthcarePartyId: cardinalApi.user?.healthcarePartyId,
  }),
)

export const DoctorsDirectory = () => {
  const { healthcarePartyId } = useAppSelector(reduxSelector)

  const { data: currentPractitioner, isLoading: practitonerIsLoading } = useGetPractitionerQuery(healthcarePartyId ?? skipToken)
  const { data: practitionersInTheGroup, isLoading: practitionerInTheGroupIsLoading } = useListHealthcarePartiesByParentIdQuery(currentPractitioner?.parentId ?? skipToken)

  return (
    <div className="patientsDirectory">
      {(practitonerIsLoading || practitionerInTheGroupIsLoading) && <Skeleton avatar paragraph={{ rows: 2 }} active style={{ padding: '16px' }} />}
      <DoctorsTable showSpinner={practitonerIsLoading || practitionerInTheGroupIsLoading} doctorsList={practitionersInTheGroup} />
    </div>
  )
}
